/**
 * Session cache for POS sales history so navigating away from /pos and back
 * does not refetch the same filter/page from the server.
 * Cleared on logout via invalidate when auth clears, or on data mutations.
 */
let cached = null;

export function getPosHistoryCacheKey(filters, page, rowsPerPage, search = '') {
  return JSON.stringify({
    st: filters.saleType ?? '',
    sd: filters.startDate ?? '',
    ed: filters.endDate ?? '',
    cu: filters.customer ?? '',
    q: search ?? '',
    p: page,
    r: rowsPerPage
  });
}

export function readPosHistoryCache(key) {
  if (!cached || cached.key !== key) return null;
  return {
    posHistory: cached.posHistory,
    historyTotalCount: cached.historyTotalCount
  };
}

export function writePosHistoryCache(key, posHistory, historyTotalCount) {
  cached = {
    key,
    posHistory,
    historyTotalCount
  };
}

export function invalidatePosHistoryCache() {
  cached = null;
}
